<template>
  <slot />
</template>
<script>
export default{
  name: 'NoLayout'
}
</script>
